import { H3, H6 } from '@liveauctioneers/hammer-ui-core/text';

import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

type Props = {
    isCatalogDone: boolean;
    isMobile: boolean;
};

export const DoneOverlay = ({ isCatalogDone, isMobile }: Props) => {
    const formatMessage = useAppFormatMessage();

    if (!isCatalogDone) {
        return null;
    }

    if (isMobile) {
        return (
            <div className="absolute inset-0 flex items-end justify-start p-2xs">
                <div className="rounded-md border border-border-secondary bg-surface-50/50 px-xs py-2xs backdrop-blur">
                    <H6>{formatMessage(['auction_has_closed'])}</H6>
                </div>
            </div>
        );
    }

    return (
        <div className="absolute inset-0 flex items-center justify-center">
            <div className="rounded-md bg-surface-50/50 px-sm py-xs backdrop-blur">
                <H3>{formatMessage(['auction_closed'])}</H3>
            </div>
        </div>
    );
};
